'use client';

export function AboutHero() {
  return (
    <section className="relative pt-4 sm:pt-8 pb-0">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 relative z-10">

        {/* Main grid */}
        <div className="grid lg:grid-cols-12 gap-6 lg:gap-10 items-end min-h-[420px] sm:min-h-[480px] lg:min-h-[540px]">

          {/* Left — typography */}
          <div className="lg:col-span-5 flex flex-col justify-end pb-8 lg:pb-12">
            <div className="space-y-5">
              {/* Label */}
              <div className="animate-fade-up">
                <span className="inline-flex items-center gap-2 text-[11px] font-bold tracking-[0.2em] uppercase text-[var(--primary)] bg-[var(--primary-subtle)] px-3 py-1.5 rounded-full">
                  <span className="w-1.5 h-1.5 rounded-full bg-[var(--primary)] animate-pulse" />
                  О нас
                </span>
              </div>

              {/* Heading */}
              <h1 className="animate-fade-up" style={{ animationDelay: '80ms' }}>
                <span className="block text-4xl sm:text-5xl lg:text-[3.5rem] font-heading font-black leading-[1] tracking-tight text-[var(--text-primary)]">
                  Fast casual
                </span>
                <span className="block text-4xl sm:text-5xl lg:text-[3.5rem] font-heading font-black leading-[1] tracking-tight text-[var(--text-primary)] mt-1">
                  роллы.
                </span>
                <span className="block text-4xl sm:text-5xl lg:text-[3.5rem] font-heading font-black leading-[1] tracking-tight text-[var(--primary)] mt-1">
                  Сервис next.
                </span>
              </h1>

              {/* Description */}
              <p
                className="text-sm sm:text-base text-[var(--text-secondary)] leading-relaxed max-w-md animate-fade-up"
                style={{ animationDelay: '160ms' }}
              >
                Мы — «Азиаточка». Специализируемся только на роллах.
                Предпочитаем проверенные ингредиенты низкой цене — это позволяет
                создавать продукт, за которым возвращаются.
              </p>
            </div>
          </div>

          {/* Right — photo, overflow-visible so image peeks above */}
          <div
            className="lg:col-span-7 animate-fade-up"
            style={{ animationDelay: '200ms', overflow: 'visible' }}
          >
            <div className="rounded-3xl overflow-hidden" style={{ overflow: 'visible' }}>
              <img
                src="https://cdn.aziatochka.ru/aziatochka/hello.webp"
                alt="Азиаточка — о нас"
                className="w-full rounded-3xl object-cover object-[center_20%]"
                style={{
                  aspectRatio: '3 / 2',
                  transform: 'translateY(-15%)',
                }}
              />
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}
